export const stringToArray = (str, separator = ',') => {
  if (!str) {
    return [];
  }
  return String(str)
    .split(separator)
    .map(item => item.trim());
};

export const arrayToStr = (arr, separator = ',') => {
  if (!arr) {
    return undefined;
  }
  let target = arr;
  if (!Array.isArray(target)) {
    target = [target];
  }

  return target
    .map(item => item.trim())
    .filter(item => !!item)
    .join(separator);
};
